import { EntityColumn } from '../types/grid';
import { Entity, PathLeaf } from '@softline/core';
import { ColumnHostRef, EntityColumnRef } from '../types/refs';
import { ColumnOptions } from '../types/column-options';

export interface EntityColumnOptions<TRow extends object, TValue extends Entity> extends ColumnOptions<TRow, TValue> {
  format: (value: TValue) => string;
  sortBy: (value: TValue) => number | string;
  rowGroup?: boolean;
  /** Render as a single plain column instead of a collapsible group. */
  flat?: boolean;
}

export function entityColumn<TRow extends object, TValue extends Entity>(ref: ColumnHostRef<TRow>,
                                                                         options: EntityColumnOptions<TRow, TValue>,
                                                                         factory: (ref: EntityColumnRef<TValue>) => void): EntityColumn<TRow, TValue> {
  const entityColRef: EntityColumnRef<TValue> = new EntityColumnRef<TValue>(ref.formatter);
  factory(entityColRef);
  const entityCol: EntityColumn<TRow, TValue> = {
    ...options,
    type: 'entity',
    children: entityColRef.columns,
  };
  ref.createColumn(entityCol as EntityColumn<TRow, any>)
  return entityCol;
}
